/**
 * Escape a string with regular expression
 *
 * @param regExp - a regular expression
 * @returns Escape string
 */
export const escapeRegExp = (regExp) => (regExp.replace(/[-[\]/{}()*+?.\\^$|]/g, '\\$&'));
